import $ from 'jquery';
import _ from 'underscore';
import screenSize from '../services/screen_size';

export default function () {
    const isWatch = $('.-watch');
    let currentCommand; // Cache current player status to avoid un necessary firing of player events

    // Do not autoplay when on mobile and Watch pages.
    if (screenSize.getSize() !== 'small' && isWatch.length === 0) {
        $(function () {

            // Cache some DOM elements
            const $iframes = $('.inline-video iframe[src*="fastcompany.com/embed"], ' +
                            '.inline-video iframe[src*="fastcocreate.com/embed"], ' +
                            '.inline-video iframe[src*="fastcodesign.com/embed"], ' +
                            '.inline-video iframe[src*="fastcoexist.com/embed"], ' +
                            '.inline-video iframe[src*="fastcompany.local:8880/embed"], ' +
                            '.inline-video iframe[src*="fastcocreate.local:8880/embed"], ' +
                            '.inline-video iframe[src*="fastcodesign.local:8880/embed"], ' +
                            '.inline-video iframe[src*="fastcoexist.local:8880/embed"]'
                        );
            const $window = $(window);
            const $doc = $(document);

            // Dev replace video embeds with local url, because locally all the video embeds are on www.fastcompany.com, this will make it localhost instead
            $iframes.each(function () {
                const $this = $(this);
                let src = $this.attr('src');
                src = src.match(/\.com/) ? src.split('.com')[1] : src.split('8880')[1];
                $this.attr('src', src);
            });

            $iframes.each(function () {
                const $this = $(this);
                $this.one('load', function () {
                    let data = {};
                    data.command = 'mute';
                    this.contentWindow.postMessage(data, '*');
                    $(this).contents().find('.video-js').append('<i class="icon-video-mute"></i>');
                });

            });

            // Define a function to call, with throttle to check video position and apply appropriate actions when scrolling.
            function _onScroll() {
                // check if the iframe DOM in cache is the same as the current iframe, if it's not, then end here
                if (!$iframes.length) {
                    return;
                }

                const winHeight = $window.height();
                const scrollTop = $doc.scrollTop();

                // Find all iframes in view and apply autoplay logic to it
                $iframes.each(function () {
                    const $this = $(this);

                    if ($($this.parent()[0]).hasClass('poster-wrapper')) {
                        return;
                    }
                    // If the iframe has disable autoinline autoplay as a data attribute, then end it here
                    if ($this.data('disableinlineautoplay')) {
                        return;
                    }

                    const height = $this.height();
                    const offset = $this.offset().top;
                    let data = {};

                    // Find videos outside of view and pause them
                    if (offset < scrollTop || scrollTop + winHeight < offset + height) {
                        if (currentCommand !== 'pause') {
                            data.command = 'pause';
                            currentCommand = data.command;
                        }
                    } else {
                        if (currentCommand !== 'play') {    // eslint-disable-line no-lonely-if
                            data.command = 'play';
                            currentCommand = data.command;
                        }
                    }

                    this.contentWindow.postMessage(data, '*');
                });
            }

            $window.bind('scroll', _.throttle(_onScroll, 300));
        });
    }
}
